import ReadableAudienceType from '@/components/Publisher/AudiencePreview/ReadableAudienceType'

import messages from './messages'

export const userColumns = ({ intl }: any) => {
  const columns = [
    {
      cell: {
        // @ts-expect-error
        formatters: [(_: any, { rowData: audience }) => <ReadableAudienceType {...audience} />],
        props: { className: 'type' }
      },
      header: {
        label: '',
        props: { className: 'type' }
      },
      property: 'readableType'
    },
    {
      cell: {
        props: { className: 'name' }
      },
      header: {
        label: intl.formatMessage(messages.username),
        props: { className: 'name' }
      },
      property: 'readableValue'
    },
    {
      cell: {
        props: { className: 'Message' }
      },
      header: {
        label: intl.formatMessage(messages.message),
        props: { className: 'message' }
      },
      property: 'message'
    }
  ]

  return columns
}

export const validationColumns = ({ intl }: any) => {
  const columns = [
    {
      cell: {
        props: { className: 'line' }
      },
      header: {
        label: intl.formatMessage(messages.line),
        props: { className: 'line' }
      },
      property: 'line'
    },
    {
      cell: {
        props: { className: 'message' }
      },
      header: {
        label: intl.formatMessage(messages.message),
        props: { className: 'message' }
      },
      property: 'message'
    }
  ]
  return columns
}

export const createdColumns = ({ baseUrl, intl }: any) => {
  const columns = [
    {
      cell: {
        // @ts-expect-error
        formatters: [(_: any, { rowData: audience }) => <ReadableAudienceType {...audience} />],
        props: { className: 'type' }
      },
      header: {
        label: '',
        props: { className: 'type' }
      },
      property: 'readableType'
    },
    {
      cell: {
        props: { className: 'name' }
      },
      header: {
        label: intl.formatMessage(messages.username),
        props: { className: 'name' }
      },
      property: 'readableValue'
    },
    {
      cell: {
        formatters: [
          // @ts-expect-error
          (_: any, { rowData: user }) => {
            return (
              <a
                href={`${baseUrl}${user.id}/edit`}
                target="_blank"
                rel="noopener noreferrer"
              >{`${baseUrl}${user.id}/edit`}</a>
            )
          }
        ],
        props: { className: 'message' }
      },
      header: {
        label: intl.formatMessage(messages.message),
        props: { className: 'message' }
      },
      property: 'id'
    }
  ]
  return columns
}
